import React from 'react';
import { Container, H5 } from '@ui';
import styled from 'styled-components';
import { selectDarkTheme } from '@utils/themes';
import { PersonProfile, PersonProfileGrid } from '@ui/PersonProfile';

const Wrapper = styled.div`
  max-width: 1600px;
  padding: 24px 60px 80px 60px;

  * {
    color: ${({ theme }) => selectDarkTheme(theme).text};
  }
`;

export const Investors = () => {
  return (
    <Wrapper>
      <Container bottom={60}>
        <H5>INVESTORS</H5>
      </Container>

      <PersonProfileGrid>
        <PersonProfile
          name={'Marc Lore'}
          imgSrc={'/images/profiles/marc.png'}
          linkedInUrl={'https://www.linkedin.com/in/marclore/'}
        >
          <ul>
            <li>Co-Founder and Managing Partner, VCP Ventures</li>
            <li>Co-Founder and CEO, Wonder</li>
            <li>Co-Owner, Minnesota Timberwolves and Lynx</li>
            <li>Previously Co-Founder and CEO of Jet.com and Quidsi</li>
            <li>Serial entrepreneur with nearly $4 billion in successful exits</li>
          </ul>
        </PersonProfile>
        <PersonProfile
          name={'Alex Rodriguez'}
          imgSrc={'/images/profiles/alex.png'}
          linkedInUrl={'https://www.linkedin.com/in/alex-rodriguez-b4161815a/'}
        >
          <ul>
            <li>Co-Founder and Managing Partner, VCP Ventures</li>
            <li>Chairman and CEO, A-Rod Corp</li>
            <li>Co-Owner, Minnesota Timberwolves and Lynx</li>
            <li>14-time Major League Baseball All-Star</li>
          </ul>
        </PersonProfile>
        <PersonProfile
          name={'Andy Brown'}
          imgSrc={'/images/profiles/andy.png'}
          linkedInUrl={'https://www.linkedin.com/in/andybrown63/'}
        >
          <ul>
            <li>CEO, Sand Hill East</li>
            <li>Board Member, Zscaler, Pure Storage, Digital Asset and others</li>
            <li>
              Previously Group CTO at UBS, CTO Infrastructure at Credit Suisse, and Chief Technology Architect at
              Merrill Lynch
            </li>
          </ul>
        </PersonProfile>
        <PersonProfile
          name={'Ritesh Vajariya'}
          imgSrc={'/images/profiles/ritesh.png'}
          linkedInUrl={'https://www.linkedin.com/in/vajariya/'}
        >
          <ul>
            <li>Global Head of GenAI Strategy and BD, Cerebras</li>
            <li>Previously Head of GenAI BD, Amazon Web Services</li>
            <li>Previously Sr. Director, Data and Machine Learning, Bloomberg</li>
          </ul>
        </PersonProfile>
      </PersonProfileGrid>
    </Wrapper>
  );
};
